import { compose, withHandlers } from "recompose";

import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

import { getTiersXtraData, setTiersXtraData } from "../../tools/tiersExtraData";

const notifications = withHandlers({
  sendSuccessCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = intl.formatMessage({ id: "ids_supplierHasBeenCreated" });
    sendNotification(notif);
  },
  sendFailureCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_supplierCreateFailed_notification"
    });
    sendNotification && sendNotification(notif);
  },
  sendSuccessUpdateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = intl.formatMessage({ id: "ids_supplierHasBeenUpdated" });
    sendNotification(notif);
  },
  sendFailureUpdateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_supplierUpdateFailed_notification"
    });
    sendNotification && sendNotification(notif);
  }
});

// const getTierses = graphql(Queries.getTierses, {
//   name: "getTierses",

//   // options: (showCollaborators) => {
//   //   fetchPolicy: "network-only",
//   //   { variables: {
//   //     { showCollaborators }
//   //   }
//   // },
//   props: ({
//     ownProps,
//     data,
//     getTierses,
//     getTierses: { refetch },
//     showSuppliers,
//     showClients,
//     showCollaborators,
//     showComptables
//   }) => {
//     // console.log("data", data);
//     // console.log("ownprops", ownProps);
//     return {
//       refetch,
//       getTierses,
//       showSuppliers,
//       showClients,
//       showCollaborators,
//       showComptables,
//       nullValue: null
//     };
//   }
// });

const handlers = withHandlers({
  deleteSuppliers: () => async data => {
    alert("not implemented yet");
    console.log("deleteSuppliers", data);
    // await Promise.all(data.map(async (expense) => {
    //   this.props.deleteExpenseMutation(expense.id);
    // }));
  },
  createSupplier: ({
    companyId,
    sendSuccessCreateNotification,
    sendFailureCreateNotification,
    createSupplierMutation,
    connectSupplierMutation
  }) => async values => {

    values["companyId"] = companyId;
    if (values.taxIdemCompany) {
      values["tax1Id"] = "";
      values["tax2Id"] = "";
    } else {
      values["tax1Id"] = values.tax1 && values.tax1.id;
      values["tax2Id"] = values.tax2 && values.tax2.id;
    }

    values["xtraData"] = setTiersXtraData(null, values.taxableValue, values.externalCodeValue, values.escomptePercentValue)

    // console.log('119 - VALUES BEFORE SUPPLIER CREATE', values);

    try {
      const mutation = await createSupplierMutation({
        variables: values
      });

      // console.log("104 - mutation=", mutation);

      if (!values.taxIdemCompany || !!values["collaboratorRespComId"]) {
        // tax connection
        values["id"] = mutation.data.createTiers.supplier.id;
        values["connectTax1"] = !!values.tax1;
        values["disconnectTax1"] = false;
        values["connectTax2"] = !!values.tax2;
        values["disconnectTax2"] = false;

        // console.log("VALUES BEFORE SUPPLIER CONNECT", values);
        const connected = await connectSupplierMutation({
          variables: values
        });
        // console.log("AFTER SUPPLIER CONNECT", connected);
      }
      sendSuccessCreateNotification();
      return mutation;
    } catch (e) {
      console.log(e);
      sendFailureCreateNotification();
    }
  },

  updateSupplier: ({
    updateSupplierMutation,
    updateAddress,
    createAddress,
    connectSupplierMutation,
    connectAddress,
    sendSuccessUpdateNotification,
    companyId,
    sendFailureUpdateNotification
  }) => async values => {
    values["tax1Id"] = values.tax1 && values.tax1.id;
    values["tax2Id"] = values.tax2 && values.tax2.id;
    values["currencyId"] = values["currency"];
    values["languageId"] = values["language"];
    values["companyId"] = companyId;
    //    values['countryId'] = values['country'];    
    // console.log('119 - VALUES BEFORE SUPPLIER UPDATE', values);

    // console.log('VALUES ADDRESSID', values['addressId']);

    const vars = {
      address: values.address || "",
      companyId: values.company,
      countryId: values.country,
      tiersId: values.id
    };
    try {
      if (values["addressId"]) {
        // update address
        vars.addressId = values["addressId"];
        vars["companyId"] = companyId;
        console.log("update Address vars", vars);
        await updateAddress({ variables: vars });
        vars["connectCountry"] = values.country !== null;

        await connectAddress({ variables: vars });
      } else {
        // create new Address
        console.log("newAddress vars", vars);
        const newAddress = await createAddress({
          variables: vars
        });
        values.addressId = newAddress.data.createAddress.id;
        values.companyId = companyId;
        vars["connectCountry"] = values.country !== null;
        await connectAddress({ variables: vars });
      }

      values.countryId = values.country;

      console.log("updateSupplierMutation", values);
      const mutation = await updateSupplierMutation({
        variables: values,
        refetchQueries: [
          {
            query: Queries.GET_SUPPLIER,
            variables: { id: values.id }
          }
        ]
      });

      // console.log("180 - mutation=", mutation);

      values["id"] = mutation.data.updateSupplier.id;
      await connectSupplierMutation({ variables: values });

      // console.log("185 - values=", values);

      sendSuccessUpdateNotification();
      return mutation;
    } catch (e) {
      console.log(e);
      sendFailureUpdateNotification();
    }
  }
});

export default compose(
  injectIntl,
  graphql(Queries.CREATE_SUPPLIER_MUTATION, { name: "createSupplierMutation" }),
  graphql(Queries.CONNECT_SUPPLIER_MUTATION, { name: "connectSupplierMutation" }),
  graphql(Queries.UPDATE_SUPPLIER_MUTATION, { name: "updateSupplierMutation" }),
  graphql(Queries.updateAddress, { name: "updateAddress" }),
  graphql(Queries.createAddress, { name: "createAddress" }),
  graphql(Queries.connectAddress, { name: "connectAddress" }),
  notifications,
  handlers
);
